import {Component, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter, Input} from '@angular/core';
import {fromEvent} from "rxjs";
import {filter, debounceTime, distinctUntilChanged, tap} from 'rxjs/operators';

@Component({
  selector: 'v-facet-search-bar',
  templateUrl: './facet-search-bar.component.html',
})
export class FacetSearchBarComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  @Output() changeVal = new EventEmitter<string>();
  @Input() progressing: boolean;

  constructor() {
  }

  ngAfterViewInit() {
    fromEvent(this.searchInput.nativeElement,'keyup').pipe(
      filter(Boolean),
      debounceTime(1000),
      distinctUntilChanged(),
      tap((event:KeyboardEvent) => {
        this.changeVal.emit(this.searchInput.nativeElement.value);
      })
    ).subscribe();
  }
}
